<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    },
    options () {
      this.$data._chart.update()
    }
  },
  methods: {
    getChartSettings () {
      const fillOptions = [{label: 'Yes', value: "start"}, {label: 'No', value: false}]
      const lineStyleOptions = [
        {label: 'Solid', value: []},
        {label: 'Dashed', value: [10, 10]},
        {label: 'Dotted', value: [5, 5]}
      ]
      const datasetSettings = [
        {
          title: "Dataset settings",
          classes: 'grid colours',
          fields: [
            {type: 'radio', label: 'Fill', options: fillOptions, name: 'fill', model: 'fill'},
            {type: 'color', label: 'Fill colour', name: 'backgroundColor', model: 'backgroundColor'},
            {type: 'color', label: 'Line colour', name: 'borderColor', model: 'borderColor'},
            {type: 'select', label: 'Line style', options: lineStyleOptions, name: 'borderDash', model: 'borderDash'},
            {type: 'number', label: 'Tension', name: 'tension', model: 'tension'},
          ]
        }
      ]

      return {chart: [], dataset: []}
    }
  }
}
</script>

<style>
</style>